export { TextStyles } from './Text.Styled'
export { default } from './Text'
